const TenantAlertDialogStyles = theme => ({
    error: { color: theme.palette.error.main },
    warning: { color: theme.palette.warning.main },
    alignCenter: { alignSelf: 'center' },
});

export default TenantAlertDialogStyles;
